import { createContext } from "react";

const WizardRedirectContext = createContext<{
  canRedirect: boolean;
  setCanRedirect: (value: boolean) => void;
}>({ canRedirect: true, setCanRedirect: () => {} });

export default WizardRedirectContext;
